var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronDisabled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.813134 0.146447C1.0084 -0.0488155 1.32498 -0.0488155 1.52024 0.146447L8.66665 7.29286C8.7596 7.38567 8.83334 7.4959 8.88365 7.61724C8.93396 7.73858 8.95986 7.86865 8.95986 8C8.95986 8.13135 8.93396 8.26142 8.88365 8.38276C8.83334 8.5041 8.7596 8.61433 8.66665 8.70714L1.52024 15.8536C1.32498 16.0488 1.0084 16.0488 0.813134 15.8536C0.617871 15.6583 0.617871 15.3417 0.813134 15.1464L7.95958 8L0.813134 0.853553C0.617871 0.658291 0.617871 0.341709 0.813134 0.146447Z",
    fill: "#60666C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDisabled);
export default __webpack_public_path__ + "static/media/chevron-disabled.7660fb7c22f2f97885aedb479e3ee413.svg";
export { ForwardRef as ReactComponent };